import React, { useState } from "react";
import { Box, Paper, Typography, TextField, Button, Alert, FormControlLabel, Checkbox } from "@mui/material";
import apiClient from "../services/apiClient";

export default function GuideLeadForm({ source = "guide-landing-page" }) {
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [email, setEmail] = useState("");
  const [consentAccepted, setConsentAccepted] = useState(false);
  const [honeypot, setHoneypot] = useState("");
  const [message, setMessage] = useState("");
  const [error, setError] = useState("");
  const [manualGuideUrl, setManualGuideUrl] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setMessage("");
    setManualGuideUrl("");
    try {
      const payload = {
        firstName,
        lastName,
        email,
        source,
        consentAccepted,
        honeypot,
      };

      const result = await apiClient.publicCaptureLead(payload);

      setMessage(
        "Demande envoyée. Ouvre le guide avec le lien ci-dessous. L'email peut arriver dans les prochaines minutes."
      );
      if (result.guideUrl) {
        setManualGuideUrl(result.guideUrl);
      }
      setFirstName("");
      setLastName("");
      setEmail("");
      setConsentAccepted(false);
    } catch (err) {
      setError(err.message || "Impossible d'envoyer la demande.");
    }
  };

  return (
    <Paper sx={{ p: 2, maxWidth: 600, mx: "auto", my: 3 }}>
      <Typography variant="h6" sx={{ mb: 1 }}>Recevoir le guide gratuit</Typography>
      <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
        Laisse ton prenom et ton email. Tu recevras le guide et la suite d'emails DigiBuddy.
      </Typography>
      {message && <Alert severity="success" sx={{ mb: 2 }}>{message}</Alert>}
      {manualGuideUrl && (
        <Alert severity="info" sx={{ mb: 2 }}>
          <a href={manualGuideUrl} target="_blank" rel="noopener noreferrer">
            Ouvrir le guide dans un nouvel onglet
          </a>{" "}
          {" • "}
          <a href={manualGuideUrl} download>
            Télécharger le PDF
          </a>
        </Alert>
      )}
      {error && <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>}
      <Box component="form" onSubmit={submit}>
        <TextField fullWidth label="Prenom" required sx={{ mb: 1 }} value={firstName} onChange={(e) => setFirstName(e.target.value)} />
        <TextField fullWidth label="Nom" sx={{ mb: 1 }} value={lastName} onChange={(e) => setLastName(e.target.value)} />
        <TextField fullWidth label="Email" type="email" required sx={{ mb: 1 }} value={email} onChange={(e) => setEmail(e.target.value)} />
        <TextField
          fullWidth
          label="Ne pas remplir ce champ"
          sx={{ mb: 1, display: "none" }}
          value={honeypot}
          onChange={(e) => setHoneypot(e.target.value)}
          tabIndex={-1}
          autoComplete="off"
        />
        <FormControlLabel
          control={<Checkbox checked={consentAccepted} onChange={(e) => setConsentAccepted(e.target.checked)} />}
          label="J'accepte l'utilisation de mes donnees pour recevoir le guide et des emails de suivi."
        />
        <Button type="submit" variant="contained" disabled={!consentAccepted}>
          Telecharger le guide
        </Button>
      </Box>
    </Paper>
  );
}
